import { getStoryFromGlobalStoryblokStoriesBySlug } from "../../utils/global-story-functions";
import { useGlobalStoryblokStories } from "../../utils/with-global-story";
import { LogoList } from "./LogoList";

export const MMTrustLogos = ({ maxLogos }: { maxLogos?: number } = {}) => {
  const globalStoryblokStories = useGlobalStoryblokStories();
  const partnerLogosStory = getStoryFromGlobalStoryblokStoriesBySlug(
    "shared-content/partner-logos/partner-logos",
    globalStoryblokStories,
  );

  return (
    <LogoList
      bloks={partnerLogosStory?.logos?.slice(0, 1)}
      maxLogos={maxLogos}
    />
  );
};
